<template>
  <div class="CircleShader">
    <!-- <canvas id="canvas" ref="canvas" class="canvas" :class="{ show: ready }"/>   -->


    <canvas id="c"></canvas>
 

  </div>
</template>

<script>

import Settings from '@/config/Settings'
// import * as THREE from 'three'

// import OrbitControls from 'three-orbitcontrols'
// import Animation from './Animation.js'
import gsap from "gsap"


export default {
  name: 'CircleShader',
  props: ['indice'],
  data: ()=>({
    ready: true,
  }),
  beforeDestroy() {
  
  },

  mounted() {

     const canvas = document.querySelector('#c');

     console.log(canvas);

  const renderer = new THREE.WebGLRenderer({canvas});
  renderer.autoClearColor = false;

  const camera = new THREE.OrthographicCamera(
    -1, // left
     1, // right
     1, // top
    -1, // bottom
    -1, // near,
     1, // far
  );
  const scene = new THREE.Scene();



    this.$nextTick(()=>{



    
  const plane = new THREE.PlaneBufferGeometry(2, 2);

   console.log('x.');

  const fragmentShader = `
  #include <common>

  uniform vec3 iResolution;
  uniform float iTime;

  // By iq: https://www.shadertoy.com/user/iq  
  // license: Creative Commons Attribution-NonCommercial-ShareAlike 3.0 Unported License.
  void mainImage( out vec4 fragColor, in vec2 fragCoord )
  {
      // Normalized pixel coordinates (from 0 to 1)
      vec2 uv = fragCoord/iResolution.xy;

      // Time varying pixel color
      vec3 col = 0.5 + 0.5*cos(iTime+uv.xyx+vec3(0,2,4));

      // Output to screen
      fragColor = vec4(col,1.0);
  }

  void main() {
    mainImage(gl_FragColor, gl_FragCoord.xy);
  }
  `;
  let uniforms = {
    iTime: { value: 0 },
    iResolution:  { value: new THREE.Vector3() },
  };
  const material = new THREE.ShaderMaterial({
    fragmentShader,
    uniforms,
  });
  scene.add(new THREE.Mesh(plane, material));

   console.log('x');

  let resizeRendererToDisplaySize = (renderer)=> {
    const canvas = renderer.domElement;
    const width = canvas.clientWidth;
    const height = canvas.clientHeight;
    const needResize = canvas.width !== width || canvas.height !== height;
    if (needResize) {
      renderer.setSize(width, height, false);
      console.log('setSize');
    }
    return needResize;
  }

  console.log('x--');

  let render = (time)=> {

    // console.log(time);

    time *= 0.001;  // convert to seconds

    resizeRendererToDisplaySize(renderer);

    const canvas = renderer.domElement;
    uniforms.iResolution.value.set(canvas.width, canvas.height, 1);
    uniforms.iTime.value = time;

    // console.log(camera);

    renderer.render(scene, camera);

    requestAnimationFrame(render);
  }

  console.log('render');

  requestAnimationFrame(render);

  })



  },

  methods:{
    // render(){ 


    //   const elapsedTime = this.$clock.getElapsedTime()
    //   // this.$mesh.rotation.y = elapsedTime * .15



    //   // this.$mesh.material.uniforms.time.value = performance.now() / 1000

    //   this.$uniforms.iResolution.value.set(600, 400, 1);
    //   this.$uniforms.iTime.value =  performance.now() / 1000

    //   console.log(this.$uniforms);


    //   this.$controls.update()
    //   this.$renderer.render(this.$scene, this.$camera)
    //   window.requestAnimationFrame(this.render) 
      
    // },

    // onWindowResize() {
    //   this.$camera.aspect = window.innerWidth / window.innerHeight
    //   this.$camera.updateProjectionMatrix()
    //   this.$renderer.setSize( window.innerWidth, window.innerHeight )
    // },
  }

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.CircleShader
  position fixed
  top 0
  width 100vw
  height 100%
  overflow hidden  
 
  canvas
    width 100%
    height 100%
    opacity 0
    transition opacity .5s
    transition-delay 1

    &.show 
      opacity 1

  &__container
     width 100%
     position relative
     container-height(2)

</style>


